import { X } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "src/components/Default/LekUI/Button";

interface SelectionBarProps {
	selectedCount: number;
	onClose: () => void;
	actions: ReactNode;
}

export const SelectionBar = ({
	selectedCount,
	onClose,
	actions,
}: SelectionBarProps) => {
	const { t } = useTranslation();

	return (
		<div className="folder-selection-bar">
			<div className="flex items-center gap-12">
				<div className="flex items-center justify-center border-radius-8 selection-count-badge">
					{selectedCount}
				</div>
				<span className="size-16">
					{t("folder.selectedElements", "Wybrane elementy")}
				</span>
			</div>
			<div className="flex items-center gap-8">
				{actions}
				<IconButton
					data-test-id="selection-close-button"
					onClick={onClose}
					className="folder-selection-bar-btn"
				>
					<X className="icon-small" />
				</IconButton>
			</div>
		</div>
	);
};
